'use strict';

var jsxRuntime = require('react/jsx-runtime');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('tailwind-merge');
require('../../Base/Layouts/FullBleed/FullBleed.js');

const SupportTextContainer = ({ errorMessage, supportMessage, currentLength, maxLength, isMaxLengthVisible })=>{
    const isSupportMessageVisible = supportMessage || isMaxLengthVisible;
    return jsxRuntime.jsxs(Box, {
        className: "flex flex-col gap-2 px-[17px]",
        "data-testid": "design-system--support-text-container",
        children: [
            errorMessage && jsxRuntime.jsx(Typography, {
                variant: "body2",
                className: "text-w-red-500",
                children: errorMessage
            }),
            isSupportMessageVisible && jsxRuntime.jsxs(Box, {
                className: "flex gap-6",
                children: [
                    jsxRuntime.jsx(Typography, {
                        variant: "body2",
                        className: "flex-1 text-w-gray-400",
                        children: supportMessage
                    }),
                    isMaxLengthVisible && jsxRuntime.jsxs(Typography, {
                        variant: "body2",
                        className: "w-[72px] text-right text-w-gray-400",
                        children: [
                            currentLength,
                            "/",
                            maxLength
                        ]
                    })
                ]
            })
        ]
    });
};

module.exports = SupportTextContainer;
